import { StandardEvents } from '@shopify/events';

class AutomobrixProductGallery extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const button = event.target.closest('[data-automobrix-thumbnail]');
    if (!button || !this.contains(button)) return;
    this.select(button);
  };

  select(button) {
    if (!button) return;
    const image = this.querySelector('[data-automobrix-main-media] img');
    if (!image || !button.dataset.imageUrl) return;
    image.src = button.dataset.imageUrl;
    image.alt = button.dataset.imageAlt || '';
    image.removeAttribute('srcset');
    this.querySelectorAll('[data-automobrix-thumbnail]').forEach((thumbnail) => {
      const selected = thumbnail === button;
      thumbnail.classList.toggle('is-active', selected);
      thumbnail.setAttribute('aria-pressed', String(selected));
    });
  }
}

class AutomobrixProduct extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.html || detail.productId !== this.dataset.productId) return;
        const source = detail.html.querySelector(`[data-automobrix-product-id="${this.dataset.productId}"]`);
        const newAvailability = source?.querySelector('[data-automobrix-availability]');
        const currentAvailability = this.querySelector('[data-automobrix-availability]');
        if (newAvailability && currentAvailability) {
          currentAvailability.replaceWith(newAvailability.cloneNode(true));
        }
        const newProductForm = source?.querySelector('[data-automobrix-product-form]');
        const currentProductForm = this.querySelector('[data-automobrix-product-form]');
        const newQuantityDefault = newProductForm?.dataset.quantityDefault;
        if (currentProductForm && newQuantityDefault) {
          currentProductForm.dataset.quantityDefault = newQuantityDefault;
          const currentQuantityInput = currentProductForm.querySelector('[data-automobrix-quantity-input]');
          if (currentQuantityInput) currentQuantityInput.value = newQuantityDefault;
        }
        const variantMediaId = detail.resource?.featured_media?.id;
        if (!variantMediaId) return;
        const matchedButton = this.querySelector(`[data-automobrix-thumbnail][data-media-id="${variantMediaId}"]`);
        const fallbackButton = this.querySelector('[data-automobrix-thumbnail]');
        this.querySelector('automobrix-product-gallery')?.select(matchedButton || fallbackButton);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[automobrix-product] Variant update failed', error);
      });
  };
}

if (!customElements.get('automobrix-product-gallery')) {
  customElements.define('automobrix-product-gallery', AutomobrixProductGallery);
}
if (!customElements.get('automobrix-product')) customElements.define('automobrix-product', AutomobrixProduct);
